module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-RegularItalic-73156bed3fd395b3364f57baeffc9587.otf";